import { LicenseInfo } from '@mui/x-license-pro';

export function setMuiXProLicenseKey() {
  LicenseInfo.setLicenseKey(
    'bd655a51ffde77e7b4ec5c682d4f4b59Tz03OTMyMSxFPTE3MzI0Mjg0MjYwMDAsUz1wcm8sTE09c3Vic2NyaXB0aW9uLEtWPTI='
  );
}
